var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showChip)?_c('v-chip',{staticClass:"rounded-tag-small",attrs:{"label":"","small":"","outlined":"","text-color":_vm.textColor,"color":"#EBBF0F"}},[_vm._v(" IPI não incluso ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }